import React from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import RadioBox from '../../components/atoms/RadioBox'
import CustomSelect from '../../components/atoms/Inputs/CustomSelect'
import CustomInput from '../../components/atoms/Inputs/CustomTextArea'
import CustomInput2 from '../../components/atoms/Inputs/CustomInput'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { useTranslation } from 'react-i18next'

const CarRegisterStepFir = ({ formik, nextStep, prevStep }) => {
    const { setFieldValue, values } = formik
    const { t } = useTranslation()

    const keyOptions = [
        { id: 'one', description: t('one/1') },
        { id: 'twoOrMore', description: t('2_or_more') },
    ]

    const tyreOptions = [
        { id: 'Summer tyres', description: t('summer_tyres') },
        { id: 'Winter tyres', description: t('winter_tyres') },
        { id: 'Both set of tyres', description: t('both_set_of_tyres') },
    ]

    const maintenanceYearOptions = [
        { id: '2025', description: '2025' },
        { id: '2024', description: '2024' },
        { id: '2023', description: '2023' },
        // { id: 'unknown', description: "Don't know" },
    ]
    const monthOptions = [
        { id: '', description: t('select_month') },
        { id: 'January', description: t('january') },
        { id: 'February', description: t('february') },
        { id: 'March', description: t('march') },
        { id: 'April', description: 'April' },
        { id: 'May', description: t('may') },
        { id: 'June', description: t('june') },
        { id: 'July', description: t('july') },
        { id: 'August', description: t('august') },
        { id: 'September', description: 'September' },
        { id: 'October', description: t('october') },
        { id: 'November', description: 'November' },
        { id: 'December', description: 'December' },
    ]

    const leasingOptions = [
        { id: 'Yes', description: t('yes') },
        { id: 'No', description: t('no') },
    ]

    const financeOptions = [
        { id: 'Yes', description: t('yes') },
        { id: 'No', description: t('no') },
    ]

    const paidOffOptions = [
        { id: 'Yes', description: t('yes') },
        { id: 'No', description: t('no') },
    ]

    return (
        <>
            <h2 className="text-left light-white mb-3">
                {t('information_about_your')} <span style={{ color: '#007776' }}>{t('car')}!</span>
            </h2>

            {/* <CustomInput2
                label="Vehicle Name"
                type="text"
                inputClassName="input-login login-user-name"
                labelClass="login-user-name-label light-white"
                placeholder="ABC12D"
                onChange={(event) => setFieldValue('protitle', event.target.value)}
                name="protitle"
                value={values.protitle}
                s
                helperText={
                    formik.touched.protitle && formik.errors.protitle
                        ? formik.errors.protitle
                        : null
                }
                error={formik.touched.protitle && formik.errors.protitle}
            /> */}
            <div className="cutomRadioButtons">
                <p className="label">
                    {t('keys')} <span>*</span>
                </p>
                <RadioBox
                    name="keys"
                    items={keyOptions}
                    value={values.keys}
                    onChange={(event) => setFieldValue('keys', event.target.value)}
                />
                {formik.errors.keys && formik.touched.keys && (
                    <div className="error-text">{formik.errors.keys}</div>
                )}
                <p className="label">
                    {t('tyres')}
                    <span>*</span>
                </p>
                <RadioBox
                    name="tyres"
                    items={tyreOptions}
                    value={values.tyres}
                    onChange={(event) => setFieldValue('tyres', event.target.value)}
                />
                {formik.errors.tyres && formik.touched.tyres && (
                    <div className="error-text">{formik.errors.tyres}</div>
                )}
                <p className="label">
                    {t('maintenance_year')}
                    <span>*</span>
                </p>
                <RadioBox
                    name="year"
                    items={maintenanceYearOptions}
                    value={values.year}
                    onChange={(event) => setFieldValue('year', event.target.value)}
                />
                {formik.errors.year && formik.touched.year && (
                    <div className="error-text">{formik.errors.year}</div>
                )}
                <p className="label">
                    {t('month')}
                    <span>*</span>
                </p>
                <CustomSelect
                    id="month"
                    placeholder={t('select_month')}
                    label={t('month')}
                    name="month"
                    value={values.month}
                    onChange={(event) => setFieldValue('month', event.target.value)}
                    selectClassName="customSelect"
                    labelClass="text-left light-white"
                >
                    {monthOptions.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.description}
                        </option>
                    ))}
                </CustomSelect>
                {formik.errors.month && formik.touched.month && (
                    <div className="error-text">{formik.errors.month}</div>
                )}
                <h3 className="text-left">{t('finance')}</h3>
                <p className="label">
                    {t('is_this_car_on_leasing')}? <span>*</span>
                </p>
                <RadioBox
                    name="leasingValue"
                    items={leasingOptions}
                    value={values.leasingValue}
                    onChange={(event) => setFieldValue('leasingValue', event.target.value)}
                />
                {values.leasingValue == 'No' && (
                    <>
                        <p className="label">
                            {t('is_the_car_on_finance_installment')}?<span>*</span>
                        </p>
                        <RadioBox
                            name="financeValue"
                            items={financeOptions}
                            value={values.financeValue}
                            onChange={(event) => setFieldValue('financeValue', event.target.value)}
                        />
                    </>
                )}
                {formik.errors.financeValue && formik.touched.financeValue && (
                    <div className="error-text">{formik.errors.financeValue}</div>
                )}
                {values.financeValue == 'Yes' && (
                    <>
                        <p className="label">
                            {t('is_the_car_paid_off')}?<span>*</span>
                        </p>
                        <RadioBox
                            name="paidOff"
                            items={paidOffOptions}
                            value={values.paidOff}
                            onChange={(event) => setFieldValue('paidOff', event.target.value)}
                        />
                    </>
                )}
                {formik.errors.paidOff && formik.touched.paidOff && (
                    <div className="error-text">{formik.errors.paidOff}</div>
                )}
                {formik.errors.leasingValue && formik.touched.leasingValue && (
                    <div className="error-text">{formik.errors.leasingValue}</div>
                )}
                <p className="label">{t('any_specific_details')}</p>
                <CustomInput
                    placeholder={t('car_specific_model')}
                    value={values.specificDetails}
                    onChange={(event) => setFieldValue('specificDetails', event.target.value)}
                />
                {formik.errors.specificDetails && formik.touched.specificDetails && (
                    <div className="error-text">{formik.errors.specificDetails}</div>
                )}
                <p className="label mt-2">{t('any_known_damages_or_issues')}</p>
                <CustomInput
                    placeholder={t('provide_details_about_any_damages_or_issues')}
                    value={values.damageNotes}
                    onChange={(event) => setFieldValue('damageNotes', event.target.value)}
                />
                {formik.errors.damageNotes && formik.touched.damageNotes && (
                    <div className="error-text">{formik.errors.damageNotes}</div>
                )}
                <PrimaryButton customClassName="mt-3" onClick={nextStep}>
                    {t('upload_car_pictures')}
                </PrimaryButton>
            </div>
        </>
    )
}

export default CarRegisterStepFir
